import { Formik, Form, ErrorMessage } from 'formik';
import * as yup from 'yup';
import { $t } from 'hooks/i18n';
import { Button } from 'primereact/button';
import { DataSource } from 'components/DataSource';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { PageRequestError } from 'components/PageRequestError';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Title } from 'components/Title';
import useApp from 'hooks/useApp';

import useEditPage from 'hooks/useEditPage';
const LeavemasterEditPage = (props) => {
		const app = useApp();
	// form validation schema
	const validationSchema = yup.object().shape({
		financialyear: yup.string().required().label($t('financialyear')),
		leavetypeid: yup.string().required().label($t('leavetypeid')),
		total_leave: yup.number().required().label($t('totalLeave')),
		max_leave_in_month: yup.number().required().label($t('maxLeaveInMonth')),
		laps_onto: yup.number().required().label($t('lapsOnto')),
		carry_forward: yup.number().nullable().label($t('carryForward')),
		carry_forward_limit: yup.number().nullable().label($t('carryForwardLimit'))
	});
	// form default values
	const formDefaultValues = {
		financialyear: '', 
		leavetypeid: '', 
		total_leave: "((0))", 
		max_leave_in_month: "((0))", 
		laps_onto: "((0))", 
		carry_forward: '', 
		carry_forward_limit: '', 
	}
	//where page logics resides
	const pageController = useEditPage({ props, formDefaultValues, afterSubmit });
	//destructure and grab what we need
	const { formData, handleSubmit, submitForm, pageReady, loading, saving, apiRequestError, inputClassName } = pageController
	//Event raised on form submit success
	function afterSubmit(response){
		app.flashMsg(props.msgTitle, props.msgAfterSave);
		if(app.isDialogOpen()){
			app.closeDialogs(); // if page is open as dialog, close dialog
		}
		else if(props.redirect) {
			app.navigate(`/leavemaster`);
		}
	}
	// loading form data from api
	if(loading){
		return (
			<div className="p-3 text-center">
				<ProgressSpinner style={{width:'50px', height:'50px'}} />
			</div>
		);
	}
	//display error page 
	if(apiRequestError){
		return (
			<PageRequestError error={apiRequestError} />
		);
	}
	//page is ready when formdata loaded successfully
	if(pageReady){
		return (
<main id="LeavemasterEditPage" className="main-page">
    { (props.showHeader) && 
    <section className="page-section mb-3" >
        <div className="container">
            <div className="grid justify-content-between align-items-center">
                { !props.isSubPage && 
                <div className="col-fixed " >
                    <Button onClick={() => app.navigate(-1)} label={$t('')}  className="p-button p-button-text " icon="pi pi-arrow-left"  />
                </div>
                }
                <div className="col " >
                    <Title title={$t('editLeavemaster')}   titleClass="text-2xl text-primary font-bold" subTitleClass="text-500"      separator={false} />
                </div>
            </div>
        </div>
    </section>
    }
    <section className="page-section " >
        <div className="container">
            <div className="grid ">
                <div className="md:col-9 sm:col-12 comp-grid" >
                    <div >
                        <Formik
                            initialValues={formData}
                            validationSchema={validationSchema} 
                            onSubmit={(values, actions) => {
                            submitForm(values);
                            }
                            }
                            >
                            { (formik) => {
                            return (
                            <Form className={`${!props.isSubPage ? 'card  ' : ''}`}>
                                <div className="grid">
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('financialyear')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="financialyear"  onChange={formik.handleChange}  value={formik.values.financialyear}   label={$t('financialyear')} type="text" placeholder={$t('enterFinancialyear')}        className={inputClassName(formik?.errors?.financialyear)} />
                                                <ErrorMessage name="financialyear" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('leavetypeid')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource   apiPath="components_data/leavetypeid_option_list"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <Dropdown  name="leavetypeid"     optionLabel="label" optionValue="value" value={formik.values.leavetypeid} onChange={formik.handleChange} options={response} label={$t('leavetypeid')}  placeholder={$t('selectAValue')}  className={inputClassName(formik?.errors?.leavetypeid)}   />
                                                    <ErrorMessage name="leavetypeid" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('totalLeave')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="total_leave"  onChange={formik.handleChange}  value={formik.values.total_leave}   label={$t('totalLeave')} type="number" placeholder={$t('enterTotalLeave')}  min={0}  step="any"    className={inputClassName(formik?.errors?.total_leave)} />
                                                <ErrorMessage name="total_leave" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('maxLeaveInMonth')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="max_leave_in_month"  onChange={formik.handleChange}  value={formik.values.max_leave_in_month}   label={$t('maxLeaveInMonth')} type="number" placeholder={$t('enterMaxLeaveInMonth')}  min={0}  step="any"    className={inputClassName(formik?.errors?.max_leave_in_month)} />
                                                <ErrorMessage name="max_leave_in_month" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('lapsOnto')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="laps_onto"  onChange={formik.handleChange}  value={formik.values.laps_onto}   label={$t('lapsOnto')} type="number" placeholder={$t('enterLapsOnto')}  min={0}  step="any"    className={inputClassName(formik?.errors?.laps_onto)} />
                                                <ErrorMessage name="laps_onto" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('carryForward')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="carry_forward"  onChange={formik.handleChange}  value={formik.values.carry_forward}   label={$t('carryForward')} type="number" placeholder={$t('enterCarryForward')}  min={0}  step="any"    className={inputClassName(formik?.errors?.carry_forward)} />
                                                <ErrorMessage name="carry_forward" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('carryForwardLimit')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="carry_forward_limit"  onChange={formik.handleChange}  value={formik.values.carry_forward_limit}   label={$t('carryForwardLimit')} type="number" placeholder={$t('enterCarryForwardLimit')}  min={0}  step="any"    className={inputClassName(formik?.errors?.carry_forward_limit)} />
                                                <ErrorMessage name="carry_forward_limit" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                { props.showFooter && 
                                <div className="text-center my-3">
                                    <Button onClick={(e) => handleSubmit(e, formik)}  type="submit" label={$t('update')} icon="pi pi-send" loading={saving} />
                                </div>
                                }
                            </Form>
                            );
                            }
                            }
                            </Formik>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
		);
	}
}
LeavemasterEditPage.defaultProps = {
	primaryKey: 'leaveid',
	pageName: 'leavemaster',
	apiPath: 'leavemaster/edit',
	routeName: 'leavemasteredit',
	submitButtonLabel: $t('update'),
	formValidationError: $t('formIsInvalid'),
	formValidationMsg: $t('pleaseCompleteTheForm'),
	msgTitle: $t('updateRecord'),
	msgAfterSave: $t('recordUpdatedSuccessfully'),
	msgBeforeSave: $t(''),
	showHeader: true,
	showFooter: true,
	redirect: true,
	isSubPage: false
}
export default LeavemasterEditPage;
